import { render, staticRenderFns } from "./Attend.vue?vue&type=template&id=51cd4d3a&"
import script from "./Attend.vue?vue&type=script&lang=js&"
export * from "./Attend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports